import { render, staticRenderFns } from "./VFatherProAppointments.vue?vue&type=template&id=c744f02e"
import script from "./VFatherProAppointments.vue?vue&type=script&lang=js"
export * from "./VFatherProAppointments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports